<template>
  <a class="logout-heads"
    @click="SignOut" 
    target="_self"
    rel="noopener noreferrer"
    aria-expanded="false">
    <div class="logout-text">
      <p>Log out</p>
    </div>
    <div class="logout-icon" >
      <fa-icon icon="fa-arrow-right-from-bracket"/>
    </div>
  </a>
  <div class="profile-topic">
    <p class="profile-header">Fill in</p>
    <p class="profile-sub">to register your profile</p>
    <div class="text-description">
      <div class="row-description">
        <div class="column-description">
          <label class="text-contain">Check the 
            <input class="text-checkbox" type="checkbox" name="title" value="" checked onclick="return false;">
            <div class="container-lock">
              <span class="unlocked"></span>
            </div>
          </label>
        </div>
        <label class="text-label">box to display information from shared link.</label>
      </div>
      Uncheck the
      <div class="eye-contain">
        <label class="checkbox-contain">
          <input class="text-checkbox" type="checkbox" value="" onclick="return false;">
          <div class="title-lock">
            <div class="title-eye-icon">
              <i class="fa fa-eye-slash eye-slash-icon"></i>
            </div>
          </div>
        </label>
      </div>
      <label class="actual-label">box to display information from actual tap.</label>
    </div>
    
    <div class="input-form">
      <form>
        <div class="form-container">
          <div class="form-checkbox">
              <label class="checkbox-contain">
                <input class="text-checkbox" type="checkbox" id="isFirstname" name="publicBox" value="" @change=onUnlockSelected()>
                <div class="input-lock">
                  <span class="unlocked"></span>
                </div>
              </label>
            </div>
            <div class="form-icon">
              <label class="checkbox-contain">
                <input class="text-checkbox" type="checkbox" id="selectedFirstname" name="actualBox" value="" @change=onEyeCloseSelected()>
                <div class="eye-lock">
                  <div class="eye-icon">
                    <i class="fa fa-eye-slash eye-slash-first"></i>
                  </div>
                </div>
              </label>
            </div>
            <div class="form-group">
              <input type="text" id="firstname" class="form-control" placeholder="First Name" @input=onStartTypeText>
              <label for="firstname" class="form-label">First Name</label>
            </div>
          
          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isLastname" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedLastname" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="lastname" class="form-control" placeholder="Last Name"  @input=onStartTypeText>
            <label for="lastname" class="form-label">Last Name</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isNickname" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedNickname" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="nickname" class="form-control" placeholder="Nickname" @input=onStartTypeText>
            <label for="nickname" class="form-label">Nickname</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isAboutMe" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedAboutMe" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="aboutme" class="form-control" placeholder="About me" @input=onStartTypeText>
            <label for="aboutme" class="form-label">About me</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isImage" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedImage" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-text">
            <div class="contain-subhead">
              <p class="text-subhead">Profile Image Upload</p>
              <p class="image-size" ><span style="color:red">*</span>(Image size not over 5MB)</p>
            </div>
            <input  class="file-input" type="file" name="file" id="file" multiple @change="onFileSelected"/>
          </div>
          <div class="form-image">
            <div v-if="this.imgCardStatus == true">
              <!-- <img id="output-img" src="../../src/assets/defaultImg.png" @error="onFileDefault" alt="" width="120"> -->
              <img id="output-img" :src="profilePicURL" @error="onFileDefault" alt="" width="120">
            </div>
            <div v-else>
              <i class="fa fa-user" id="user-img" aria-hidden="true"></i>
            </div>
            <div class="image-filename">
              <p class="text-file">{{filename}}</p>
            </div>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isJobTitle" name="publicBox" value="" @change=onUnlockSelected()> 
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedJobTitle" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="jobtitle" class="form-control" placeholder="Job Title" @input=onStartTypeText>
            <label for="jobtitle" class="form-label">Job Title</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isOrganization" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedOrganization" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="organization" class="form-control" placeholder="Organization" @input=onStartTypeText>
            <label for="organization" class="form-label">Orgnization</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isEmail" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedEmail" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="email" name="socialInput" id="email" class="form-control" placeholder="Email" @input="onStartTypeText"/>
            <label for="email" class="form-label">Email</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isMobile" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedMobile" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="mobile" class="form-control" placeholder="Mobile Phone" @input=onStartTypeText>
            <label for="mobile" class="form-label">Mobile Phone</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isWebsite" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedWebsite" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="website" name="socialInput" class="form-control" placeholder="Website" @input=onStartTypeText>
            <label for="website" class="form-label">Website</label>
          </div>
          <div class="form-text">
            <p class="text-subhead">Social Media</p>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isLinkedIn" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedLinkedIn" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="url" id="linkedin" name="socialInput" class="form-control" placeholder="Linkedin" @input=onStartTypeText>
            <label for="linkedin" class="form-label">LinkedIn</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isFacebook" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedFacebook" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="url" id="facebook" name="socialInput" class="form-control" placeholder="Facebook" @input=onStartTypeText>
            <label for="facebook" class="form-label">Facebook</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isInstagram" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedInstagram" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="url" id="instagram" name="socialInput" class="form-control" placeholder="Instagram" @input=onStartTypeText>
            <label for="instagram" class="form-label">Instagram</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isTwitter" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedTwitter" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="url" id="twitter" name="socialInput" class="form-control" placeholder="Twitter" @input=onStartTypeText>
            <label for="twitter" class="form-label">Twitter</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isLine" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedLine" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="line" name="socialInput" class="form-control" placeholder="Line ID" @input=onStartTypeText>
            <label for="line" class="form-label">Line ID</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isWeChat" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedWeChat" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="text" id="wechat" name="socialInput" class="form-control" placeholder="WeChat ID" @input=onStartTypeText>
            <label for="wechat" class="form-label">WeChat Account/Mobile No.</label>
          </div>

          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isWhatsApp" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedWhatsApp" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-group">
            <input type="number" id="whatsapp" name="socialInput" class="form-control" placeholder="WhatsApp Number" @input=onStartTypeText>
            <label for="whatsapp" class="form-label">WhatsApp Mobile No.</label>
          </div>
          
          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isKakao" name="publicBox" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedKakao" name="actualBox" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-url">
            <div class="contain-subhead">
              <p class="text-qr-subhead">Kakao QRcode Image</p>
            </div>
            <input class="file-input" type="file" name="qrPic" id="qrPic" multiple @change="onQRDecode"/>
          </div>
          <div class="form-qr">
            <div v-if="this.imgQRcodeStatus == true">
              <img id="qr-img" :src="kakaoPicURL" @error="onFileDefault" alt="" width="120">
            </div>
            <div v-else>
              <i class="fa fa-qrcode" id="user-img" aria-hidden="true"></i>
            </div>
            <div class="image-filename">
              <p class="text-file">{{kakaoFilename}}</p>
            </div>
          </div>
          <div class="form-group">
            <p id="kakao" class="qr-url">{{kakaoURL}}</p>
            <!-- <input type="text" id="kakao" name="socialInput" class="form-control" placeholder="Kakao ID"/> -->
          </div>
          
          <div class="form-checkbox">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="isVcard" name="isVcard" value="" @change=onUnlockSelected()>
              <div class="input-lock">
                <span class="unlocked"></span>
              </div>
            </label>
          </div>
          <div class="form-icon">
            <label class="checkbox-contain">
              <input class="text-checkbox" type="checkbox" id="selectedVcard" name="selectedVcard" value="" @change=onEyeCloseSelected()>
              <div class="eye-lock">
                <div class="eye-icon">
                  <i class="fa fa-eye-slash eye-slash-info"></i>
                </div>
              </div>
            </label>
          </div>
          <div class="form-card">
            <div class="contain-subhead">
              <p class="text-subhead">Shares Contact File</p>
            </div>
          </div>
          <div class="btn-contain">
            <input type="submit" class="submit-btn" value="Submit" @click="saveBizCard" return="false"> 
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import swal from 'sweetalert2';
import actions from '../store/user/actions.js'
import auths from '../store/auth/auths.js';
import { Decoder } from '@nuintun/qrcode';

export default {
  name: 'RegisterProfile',
  data() {
    return {
      account: undefined,
      filename: 'No file chosen',
      selectedFile: null,
      profilePicURL: '',
      textCardStatus: false,
      imgCardStatus: false,
      cipherText: '',
      imgQRcodeStatus: false,
      kakaoFilename: 'No file chosen',
      kakaoPicURL: '',
      kakaoURL: '',
    };
  },
  
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.cipherText = urlParams.get("cpt");
  },
  mounted() {
    if (auths.myMSAL == '')
    {
      return;
    }
    else
    {
      this.initialUser();
      this.onUnlockSelected();
    }
  },
  methods: {
    ...mapMutations(['setAccessToken']),
    async SignOut() {
      this.account = null;
      this.$store.commit('setAccessToken', null);
      var authStatus = await auths.SignOut();
      if(authStatus == true){
        this.$emitter.emit('logout');
      }
    },
    initialUser (){     
      var result = actions.initialUserResult;
      var sicBizCardInfo = result.user;

      console.log(sicBizCardInfo);

      if(result.status == "Success")
      {
        // info
        document.getElementById("firstname").value = sicBizCardInfo.firstname;
        document.getElementById("lastname").value = sicBizCardInfo.lastname;	
        document.getElementById("nickname").value = sicBizCardInfo.nickname;	
        document.getElementById("aboutme").value = sicBizCardInfo.aboutMe;	
        document.getElementById("jobtitle").value = sicBizCardInfo.jobTitle;
        document.getElementById("organization").value = sicBizCardInfo.organization;
        document.getElementById("email").value = sicBizCardInfo.email; 
        document.getElementById("mobile").value = sicBizCardInfo.mobile;	 	 
        document.getElementById("website").value = sicBizCardInfo.website;
        // if(sicBizCardInfo.website == "")
        // {
        //   document.getElementById("website").value = "https://"
        // }
        document.getElementById("linkedin").value = sicBizCardInfo.linkedIn;
        document.getElementById("facebook").value = sicBizCardInfo.facebook;
        document.getElementById("instagram").value = sicBizCardInfo.instagram;
        document.getElementById("twitter").value = sicBizCardInfo.twitter;
        document.getElementById("line").value = sicBizCardInfo.line;
        document.getElementById("wechat").value = sicBizCardInfo.weChat;
        document.getElementById("whatsapp").value = sicBizCardInfo.whatsApp;
        document.getElementById("kakao").value = sicBizCardInfo.kakao;
        this.kakaoURL = sicBizCardInfo.kakao;
        if(sicBizCardInfo.imageUri != null)
        {
          this.imgCardStatus = true;
          this.profilePicURL = sicBizCardInfo.imageUri;
        }

        // checkbox public
        document.getElementById("isFirstname").checked = sicBizCardInfo.isFirstname;
        document.getElementById("isLastname").checked = sicBizCardInfo.isLastname;
        document.getElementById("isNickname").checked = sicBizCardInfo.isNickname;
        document.getElementById("isAboutMe").checked = sicBizCardInfo.isAboutMe;	
        document.getElementById("isJobTitle").checked = sicBizCardInfo.isJobTitle;
        document.getElementById("isOrganization").checked = sicBizCardInfo.isOrganization;
        document.getElementById("isEmail").checked = sicBizCardInfo.isEmail; 
        document.getElementById("isMobile").checked = sicBizCardInfo.isMobile;	 	 
        document.getElementById("isWebsite").checked = sicBizCardInfo.isWebsite;
        document.getElementById("isLinkedIn").checked = sicBizCardInfo.isLinkedIn;
        document.getElementById("isFacebook").checked = sicBizCardInfo.isFacebook;
        document.getElementById("isInstagram").checked = sicBizCardInfo.isInstagram;
        document.getElementById("isTwitter").checked = sicBizCardInfo.isTwitter;
        document.getElementById("isLine").checked = sicBizCardInfo.isLine;
        document.getElementById("isWeChat").checked = sicBizCardInfo.isWeChat;
        document.getElementById("isWhatsApp").checked = sicBizCardInfo.isWhatsApp;
        document.getElementById("isKakao").checked = sicBizCardInfo.isKakao;
        document.getElementById("isImage").checked = sicBizCardInfo.isImage;
        document.getElementById("isVcard").checked = sicBizCardInfo.isVcard;

        // checkbox select show
        document.getElementById("selectedFirstname").checked = sicBizCardInfo.selectedFirstname;
        document.getElementById("selectedLastname").checked = sicBizCardInfo.selectedLastname;
        document.getElementById("selectedNickname").checked = sicBizCardInfo.selectedNickname;
        document.getElementById("selectedAboutMe").checked = sicBizCardInfo.selectedAboutMe;	
        document.getElementById("selectedJobTitle").checked = sicBizCardInfo.selectedJobTitle;
        document.getElementById("selectedOrganization").checked = sicBizCardInfo.selectedOrganization;
        document.getElementById("selectedEmail").checked = sicBizCardInfo.selectedEmail; 
        document.getElementById("selectedMobile").checked = sicBizCardInfo.selectedMobile;	 	 
        document.getElementById("selectedWebsite").checked = sicBizCardInfo.selectedWebsite;
        document.getElementById("selectedLinkedIn").checked = sicBizCardInfo.selectedLinkedIn;
        document.getElementById("selectedFacebook").checked = sicBizCardInfo.selectedFacebook;
        document.getElementById("selectedInstagram").checked = sicBizCardInfo.selectedInstagram;
        document.getElementById("selectedTwitter").checked = sicBizCardInfo.selectedTwitter;
        document.getElementById("selectedLine").checked = sicBizCardInfo.selectedLine;
        document.getElementById("selectedWeChat").checked = sicBizCardInfo.selectedWeChat;
        document.getElementById("selectedWhatsApp").checked = sicBizCardInfo.selectedWhatsApp;
        document.getElementById("selectedKakao").checked = sicBizCardInfo.selectedKakao;
        document.getElementById("selectedImage").checked = sicBizCardInfo.selectedImage;
        document.getElementById("selectedVcard").checked = sicBizCardInfo.selectedVcard;

        if(document.getElementById("email").value != "") {
          console.log("ok");
          document.getElementById("selectedEmail").checked = true;
        }
        
        if(actions.recieveNewsStatus == false) {
          actions.isAccepted = sicBizCardInfo.isAccept;
          actions.isReceiveNews = sicBizCardInfo.isReceiveNews;
        }

        document.getElementById("selectedVcard").checked = true;
      } 
    },
    async saveBizCard(event) {
      if((this.$store.state.accessToken == "") || (this.$store.state.accessToken == null)) {
        await actions.getAccessToken(auths.myMSALConfig);
      }

      if(actions.checkaccessTokenStatus == true)
      {
        this.$store.commit('setAccessToken',actions.accessTokenResponse);

        var typeStatus = false;
        var firstNameStatus = false
        typeStatus = this.checkInputType();
        firstNameStatus = this.checkFirstName();
        
        if((typeStatus != false)) {
          if(firstNameStatus != false) {
            event.preventDefault();
            let token = this.$store.state.accessToken;

            const headers = new Headers();
            const bearer = `Bearer ${token}`;
            headers.append("Authorization", bearer);

            const savedInput =
              JSON.stringify({
                "sic43nt": this.cipherText,
                "user": {
                  "Firstname": document.getElementById("firstname").value,
                  "IsFirstname": document.getElementById("isFirstname").checked,
                  "SelectedFirstname": document.getElementById("selectedFirstname").checked,
                  "Lastname": document.getElementById("lastname").value,
                  "IsLastname": document.getElementById("isLastname").checked,
                  "SelectedLastname": document.getElementById("selectedLastname").checked,
                  "Nickname": document.getElementById("nickname").value,
                  "IsNickname": document.getElementById("isNickname").checked,
                  "SelectedNickname": document.getElementById("selectedNickname").checked,
                  "AboutMe": document.getElementById("aboutme").value,
                  "IsAboutMe": document.getElementById("isAboutMe").checked,
                  "SelectedAboutMe": document.getElementById("selectedAboutMe").checked,
                  "JobTitle": document.getElementById("jobtitle").value,
                  "IsJobTitle": document.getElementById("isJobTitle").checked,
                  "SelectedJobTitle": document.getElementById("selectedJobTitle").checked,
                  "Organization": document.getElementById("organization").value,
                  "IsOrganization": document.getElementById("isOrganization").checked,
                  "SelectedOrganization": document.getElementById("selectedOrganization").checked,
                  "Email": document.getElementById("email").value,
                  "IsEmail": document.getElementById("isEmail").checked,
                  "SelectedEmail": document.getElementById("selectedEmail").checked,
                  "Mobile": document.getElementById("mobile").value.split(' ').join(''),
                  "IsMobile": document.getElementById("isMobile").checked,
                  "SelectedMobile": document.getElementById("selectedMobile").checked,
                  "Website": document.getElementById("website").value,
                  "IsWebsite": document.getElementById("isWebsite").checked,
                  "SelectedWebsite": document.getElementById("selectedWebsite").checked,
                  "LinkedIn": document.getElementById("linkedin").value,
                  "IsLinkedIn": document.getElementById("isLinkedIn").checked,
                  "SelectedLinkedIn": document.getElementById("selectedLinkedIn").checked,
                  "Facebook": document.getElementById("facebook").value,
                  "IsFacebook": document.getElementById("isFacebook").checked,
                  "SelectedFacebook": document.getElementById("selectedFacebook").checked,
                  "Instagram": document.getElementById("instagram").value,
                  "IsInstagram": document.getElementById("isInstagram").checked,
                  "SelectedInstagram": document.getElementById("selectedInstagram").checked,
                  "Twitter": document.getElementById("twitter").value,
                  "IsTwitter": document.getElementById("isTwitter").checked,
                  "SelectedTwitter": document.getElementById("selectedTwitter").checked,
                  "Line": document.getElementById("line").value,
                  "IsLine": document.getElementById("isLine").checked,
                  "SelectedLine": document.getElementById("selectedLine").checked,
                  "WeChat": document.getElementById("wechat").value,
                  "IsWeChat": document.getElementById("isWeChat").checked,
                  "SelectedWeChat": document.getElementById("selectedWeChat").checked,
                  "WhatsApp": document.getElementById("whatsapp").value,
                  "IsWhatsApp": document.getElementById("isWhatsApp").checked,
                  "SelectedWhatsApp": document.getElementById("selectedWhatsApp").checked,
                  "Kakao": this.kakaoURL,
                  "IsKakao": document.getElementById("isKakao").checked,
                  "SelectedKakao": document.getElementById("selectedKakao").checked,
                  "IsImage": document.getElementById("isImage").checked,
                  "SelectedImage": document.getElementById("selectedImage").checked,
                  "IsVcard": document.getElementById("isVcard").checked,
                  "SelectedVcard": document.getElementById("selectedVcard").checked,
                  "IsAccept": actions.isAccepted,
                  "IsReceiveNews": actions.isReceiveNews,
                }
              });
            
            actions.savedInput = savedInput;
            actions.profilePic = this.selectedFile;

            this.$emitter.emit('savecard');
          }
          else
          {
            event.preventDefault();
          }
        }
      }
    },
    onFileSelected(event) {
      if (event.target.files[0].size <= 5*1024*1024) {
        const curFile = document.getElementById("file").files;
        this.filename = curFile[0].name;
        this.profilePicURL = URL.createObjectURL(event.target.files[0]);
        this.selectedFile = event.target.files[0];
        this.imgCardStatus = true;
        document.getElementById("selectedImage").checked = true;
      }
      else {
        this.imgCardStatus = false;
        swal.fire({   
          text: "File size exceeds 5 MB",     
          showCancelButton: false,   
          confirmButtonColor: "#DD6B55",   
        })
        this.imgCardStatus = false;
      }
    },
    onFileDefault(event) {
      event.target.src = this.profilePicURL;
      event.onerror = null;
    },
    onEyeCloseSelected() {
      if(document.getElementById("selectedFirstname").checked == false) {
        document.getElementById("isFirstname").checked = false;
      }
      if(document.getElementById("selectedLastname").checked == false) {
        document.getElementById("isLastname").checked = false;
      }
      if(document.getElementById("selectedNickname").checked == false) {
        document.getElementById("isNickname").checked = false;
      }
      if(document.getElementById("selectedAboutMe").checked == false) {
        document.getElementById("isAboutMe").checked = false;
      }	
      if(document.getElementById("selectedJobTitle").checked == false) {
        document.getElementById("isJobTitle").checked = false;
      }
      if(document.getElementById("selectedOrganization").checked == false) {
        document.getElementById("isOrganization").checked = false;
      }
      if(document.getElementById("selectedEmail").checked == false) {
        document.getElementById("isEmail").checked = false;
      } 
      if(document.getElementById("selectedMobile").checked == false) {
        document.getElementById("isMobile").checked = false;
      } 	 
      if(document.getElementById("selectedWebsite").checked == false) {
        document.getElementById("isWebsite").checked = false;
      }
      if(document.getElementById("selectedLinkedIn").checked == false) {
        document.getElementById("isLinkedIn").checked = false;
      }
      if(document.getElementById("selectedFacebook").checked == false) {
        document.getElementById("isFacebook").checked = false;
      }
      if(document.getElementById("selectedInstagram").checked == false) {
        document.getElementById("isInstagram").checked = false;
      }
      if(document.getElementById("selectedTwitter").checked == false) {
        document.getElementById("isTwitter").checked = false;
      }
      if(document.getElementById("selectedLine").checked == false) {
        document.getElementById("isLine").checked = false;
      }
      if(document.getElementById("selectedWeChat").checked == false) {
        document.getElementById("isWeChat").checked = false;
      }
      if(document.getElementById("selectedWhatsApp").checked == false) {
        document.getElementById("isWhatsApp").checked = false;
      }
      if(document.getElementById("selectedKakao").checked == false) {
        document.getElementById("isKakao").checked = false;
      }
      if(document.getElementById("selectedImage").checked == false) {
        document.getElementById("isImage").checked = false;
      }
      if(document.getElementById("selectedVcard").checked == false) {
        document.getElementById("isVcard").checked = false;
      }
    },
    onUnlockSelected() {
      if(document.getElementById("isFirstname").checked == true) {
        document.getElementById("selectedFirstname").checked = true;
      }
      if(document.getElementById("isLastname").checked == true) {
        document.getElementById("selectedLastname").checked = true;
      }
      if(document.getElementById("isNickname").checked == true) {
        document.getElementById("selectedNickname").checked = true;
      }
      if(document.getElementById("isAboutMe").checked == true) {
        document.getElementById("selectedAboutMe").checked = true;
      }	
      if(document.getElementById("isJobTitle").checked == true) {
        document.getElementById("selectedJobTitle").checked = true;
      }
      if(document.getElementById("isOrganization").checked == true) {
        document.getElementById("selectedOrganization").checked = true;
      }
      if(document.getElementById("isEmail").checked == true) {
        document.getElementById("selectedEmail").checked = true;
      } 
      if(document.getElementById("isMobile").checked == true) {
        document.getElementById("selectedMobile").checked = true;
      } 	 
      if(document.getElementById("isWebsite").checked == true) {
        document.getElementById("selectedWebsite").checked = true;
      }
      if(document.getElementById("isLinkedIn").checked == true) {
        document.getElementById("selectedLinkedIn").checked = true;
      }
      if(document.getElementById("isFacebook").checked == true) {
        document.getElementById("selectedFacebook").checked = true;
      }
      if(document.getElementById("isInstagram").checked == true) {
        document.getElementById("selectedInstagram").checked = true;
      }
      if(document.getElementById("isTwitter").checked == true) {
        document.getElementById("selectedTwitter").checked = true;
      }
      if(document.getElementById("isLine").checked == true) {
        document.getElementById("selectedLine").checked = true;
      }
      if(document.getElementById("isWeChat").checked == true) {
        document.getElementById("selectedWeChat").checked = true;
      }
      if(document.getElementById("isWhatsApp").checked == true) {
        document.getElementById("selectedWhatsApp").checked = true;
      }
      if(document.getElementById("isKakao").checked == true) {
        document.getElementById("selectedKakao").checked = true;
      }
      if(document.getElementById("isImage").checked == true) {
        document.getElementById("selectedImage").checked = true;
      }
      if(document.getElementById("isVcard").checked == true) {
        document.getElementById("selectedVcard").checked = true;
      }
    },
    onStartTypeText(event) {
      console.log(event);
      if(event.target.id == "firstname") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedFirstname").checked = true;
        }
        else {
          document.getElementById("selectedFirstname").checked = false;
        }
      }
      else if(event.target.id == "lastname") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedLastname").checked = true;
        }
        else {
          document.getElementById("selectedLastname").checked = false;
        }
      }
      else if(event.target.id == "nickname") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedNickname").checked = true;
        }
        else {
          document.getElementById("selectedNickname").checked = false;
        }
      }
      else if(event.target.id == "aboutme") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedAboutMe").checked = true;
        }
        else {
          document.getElementById("selectedAboutMe").checked = false;
        }
      }	
      else if(event.target.id == "jobtitle") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedJobTitle").checked = true;
        }
        else {
          document.getElementById("selectedJobTitle").checked = false;
        }
      }
      else if(event.target.id == "organization") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedOrganization").checked = true;
        }
        else {
          document.getElementById("selectedOrganization").checked = false;
        }
      }
      else if(event.target.id == "email") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedEmail").checked = true;
        }
        else {
          document.getElementById("selectedEmail").checked = false;
        }
      } 
      else if(event.target.id == "mobile") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedMobile").checked = true;
        }
        else {
          document.getElementById("selectedMobile").checked = false;
        }
      } 	
      else if(event.target.id == "website") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedWebsite").checked = true;
        }  
        else {
          document.getElementById("selectedWebsite").checked = false;
        }
      }
      else if(event.target.id == "linkedin") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedLinkedIn").checked = true;
        }  
        else {
          document.getElementById("selectedLinkedIn").checked = false;
        }
      }
      else if(event.target.id == "facebook") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedFacebook").checked = true;
        }
        else {
          document.getElementById("selectedFacebook").checked = false;
        }
      }
      else if(event.target.id == "instagram") { 
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedInstagram").checked = true;
        }
        else {
          document.getElementById("selectedInstagram").checked = false;
        }
      }
      else if(event.target.id == "twitter") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedTwitter").checked = true;
        }
        else {
          document.getElementById("selectedTwitter").checked = false;
        }
      }
      else if(event.target.id == "line") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedLine").checked = true;
        }
        else {
          document.getElementById("selectedLine").checked = false;
        }
      }
      else if(event.target.id == "wechat") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedWeChat").checked = true;
        }
        else {
          document.getElementById("selectedWeChat").checked = false;
        }
      }
      else if(event.target.id == "whatsapp") {
        if(document.getElementById(event.target.id).value != "") {
          document.getElementById("selectedWhatsApp").checked = true;
        }
        else {
          document.getElementById("selectedWhatsApp").checked = false;
        }
      }
      this.onEyeCloseSelected();
    },
    checkInputType()
    {
      var socialInput= document.getElementsByName('socialInput');
      for(var i = 0; i < socialInput.length; i++) {  
        if(socialInput[i].validity.valid == false)  
        {
          return false;
        }
      }
      return true;
    },
    checkFirstName() {
      if(document.getElementById("firstname").value != "")
      {
        return true
      }
      else
      {
        swal.fire({   
          text: "Please fill in your first name",     
          showCancelButton: false,   
          confirmButtonColor: "#DD6B55",   
        })
        return false
      }
    },
    onQRDecode(event) {
      const curFile = document.getElementById("qrPic").files;
      this.kakaoFilename = curFile[0].name;
      this.kakaoPicURL = URL.createObjectURL(event.target.files[0]);
      this.imgQRcodeStatus = true;

      const qrcode = new Decoder();
      qrcode
      .scan(this.kakaoPicURL)
      .then(result => {
        console.log(result.data);
        // this.kakaoURL = result.data;
        document.getElementById("kakao").value = result.data;
        document.getElementById("selectedKakao").checked = true;
      })
      .catch(error => {
        console.error(error.data);
      });
    },
  }
}
</script>

<style>
.check-text input {
  display: none;
}
.check-text input ~ span {
  color: #333;
  cursor: pointer;
  padding: 6px;
  border-radius: 2px;
  font-weight: 200;
}
.check-text input ~ .checked {
  display: none;
}
.check-text input:checked ~ .checked {
  display: inline-block;
}
.check-text input:checked ~ .unchecked {
  display: none;
}
.check-text input:disabled ~ span {
  color: #999;
  cursor: not-allowed;
}
.blackNwhite {
  position: absolute;
  background-color: black;
  height: 100%;
  width: 100%;
}
.logout-text {
  color: white;
  margin-right: 0.5rem;
}
.logout-heads {
  margin: 0;
  padding-top: 5%;
  margin-right: 5%;
  display: flex;
  align-items: center;
  justify-content: right;
  text-align: right;
}
.logout-icon {
  color: white;
  font-size: 1.5em;
}
.profile-header {
  color: #3cd2ef;
  margin: 0;
  font-size: 2.5em;
  font-weight: bold;
}
.profile-sub {
  margin: 0;
  color: white;
  font-size: 1.1em;
}
.profile-topic {
  margin: auto;
  width: 81%;
}
.text-contain {
  margin-bottom: 0.2em;
  line-height: 2;
}
.text-label {
  margin-left: 0.5rem;
  line-height: 2;
}
.actual-label {
  margin-left: 1.9rem;
  line-height: 2;
}
.text-checkbox {
  vertical-align: middle;
  position: relative;
  bottom: 1px;
}
.text-description {
  margin: 0;
  margin-top: 0.7rem;
  color: white;
  font-size: 0.8rem;
  position: relative;
}
.eye-contain {
  position: absolute;
  margin-left: 4.3rem;
  margin-top: -1.4rem;
}
.row-description:after {
  content: "";
  display: table;
  clear: both;
  width: 100%;
}
.column-description {
  float: left;
}
.text-contain input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  margin-bottom: 1rem;
}
.container-lock {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.2rem;
  flex: 1;
  display: flex;
  justify-content: center;
  margin-left: 4.3rem;
  margin-top: -1.5rem;
  background-color: #eee;
}
/* On mouse-over, add a grey background color */
.text-contain:hover input ~ .container-lock {
  background-color: #eee;
}
/* When the checkbox is checked, add a blue background */
.text-contain input:checked ~ .container-lock {
  background-color: #00bfe6;
}
/* Show the checkmark when checked */
.text-contain input:checked ~ .container-lock:after {
  display: block;
}
.unlocked {
  margin-top: 0.4rem;
  width: 0.5rem;
  height: 0.4rem;
  border: 0.1rem solid #3c9bef;
  border-radius: 2.5px;
  position: relative;
  cursor: pointer;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}
.unlocked:after {
  content: "";
  display: block;
  background: #3c9bef;
  width: 1.5px;
  height: 2.5px;
  position: absolute;
  margin-left: 0.2rem;
  margin-top: 0.15rem;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}
.unlocked:before {
  content: "";
  display: block;
  width: 3.5px;
  height: 3.5px;
  bottom: 100%;
  position: absolute;
  left: 50%;
  margin-left: -3px;
  border: 0.1rem solid #3c9bef;
  border-top-right-radius: 50%;
  border-top-left-radius: 50%;
  border-bottom: 0;
  -webkit-transition: all 0.1s ease-in-out;
  transition: all 0.1s ease-in-out;
}
.text-contain input:checked ~ .container-lock .unlocked {
  transform: rotate(10deg);
  margin-top: 7px;
  border-color: white;
}
/* Show the checkmark when checked */
.text-contain input:checked ~ .container-lock .unlocked:before {
  display: block;
  bottom: 130%;
  margin-left: -5.5px;
  transform: rotate(-45deg);
  border-color: white;
}
.text-contain input:checked ~ .container-lock .unlocked:after {
  background-color: white;
}
.grid-container {
  display: grid;
  grid-template-columns: auto auto auto;
}
.grid-item {
  height: 2rem;
}
.form-checkbox {
  margin: 0;
  color: white;
  font-size: 0.6em;
  position: relative;
}
.input-lock {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 0.2rem;
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: 2px;
  margin-left: 0.2px;
  background-color: #eee;
  position: absolute;
}
.eye-icon {
  font-size: 0.8rem;
  margin: auto;
}
.title-eye-icon:before {
  font-size: 0.8rem;
  margin: auto;
}
.eye-slash-icon {
  margin-top: 0.2rem;
}
.eye-slash-info {
  transform: translateY(-0.6px);
}
.eye-slash-first {
  transform: translateY(-0.4px);
}
.eye-lock {
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 0.2rem;
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: 2px;
  /* margin-left: 0.2px; */
  background-color: #eee;
  position: absolute;
  color: #3c9bef;
}
.title-lock {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 0.2rem;
  flex: 1;
  display: flex;
  justify-content: center;
  margin-top: 2px;
  margin-left: 15px;
  background-color: #eee;
  position: absolute;
  color: #3c9bef;
}
.checkbox-contain input:checked ~ .title-lock {
  color: white;
  background-color: #00bfe6;
}
.checkbox-contain input:checked ~ .title-lock {
  color: white;
  background-color: #00bfe6;
}
.checkbox-contain input:checked ~ .title-lock .fa-eye-slash {
  content: "\f070";
}
/* Show the checkmark when checked */
.checkbox-contain input:checked ~ .title-lock .fa-eye-slash:before {
  content: "\f06e";
}
/* When the checkbox is checked, add a blue background */
.checkbox-contain input:checked ~ .eye-lock {
  color: white;
  background-color: #00bfe6;
}
.checkbox-contain input:checked ~ .eye-lock .fa-eye-slash {
  content: "\f070";
}
/* Show the checkmark when checked */
.checkbox-contain input:checked ~ .eye-lock .fa-eye-slash:before {
  content: "\f06e";
}

/* Show the checkmark when checked */
.checkbox-contain input:checked ~ .eye-lock .unlocked:before {
  display: block;
  bottom: 130%;
  margin-left: -5.5px;
  transform: rotate(-45deg);
  border-color: white;
}
.checkbox-contain input:checked ~ .eye-lock .unlocked:after {
  background-color: white;
}
/* On mouse-over, add a grey background color */
.checkbox-contain:hover input ~ .input-lock {
  background-color: #eee;
}
/* When the checkbox is checked, add a blue background */
.checkbox-contain input:checked ~ .input-lock {
  background-color: #00bfe6;
  border-color: white;
}
/* Show the checkmark when checked */
.checkbox-contain input:checked ~ .input-lock:after {
  display: block;
  border-color: white;
}
.checkbox-contain input:checked ~ .input-lock .unlocked {
  transform: rotate(10deg);
  margin-top: 7px;
  border-color: white;
}
/* Show the checkmark when checked */
.checkbox-contain input:checked ~ .input-lock .unlocked:before {
  display: block;
  bottom: 130%;
  margin-left: -5.5px;
  transform: rotate(-45deg);
  border-color: white;
}
.checkbox-contain input:checked ~ .input-lock .unlocked:after {
  background-color: white;
}
.head-checkbox {
  margin: 0;
  margin-top: 1.4em;
  color: white;
  font-size: 0.6em;
  position: relative;
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkbox-contain {
  vertical-align: middle;
  position: relative;
  bottom: 1px;
}
/* Hide the browser's default checkbox */
.checkbox-contain input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  margin-bottom: 1rem;
}
.contain-subhead {
  float: left;
}
.image-filename {
  font-size: 0.8em;
  color: white;
  justify-content: center; 
  align-items: center;
  text-align: center;
  width: 45%;
  margin: auto;
  overflow-wrap: break-word;
}
.text-file {
  color: white;
}
.text-subhead {
  margin: 0;
  color: white;
  font-size: 0.9em;
  /* margin-left: 0.2rem; */
}
.qr-url {
  color: white;
  font-size: 0.9em;
  overflow-wrap: break-word;
  margin-bottom: 2.5rem;
}
.text-qr-subhead {
  margin: 0;
  color: white;
  font-size: 0.9em;
  margin-top: -1rem;
}
.text-term {
  margin-left: 2em;
}
.image-size {
  margin: 0;
  margin-top: 1em;
  color: white;
  font-size: 0.7em;
}
.file-input {
  color: transparent;
  width: 40%;
}
.file-input::-webkit-file-upload-button {
  visibility: hidden;
}
.file-input::before {
  content: 'Upload';
  color: white;
  padding: 12px 15px;
  transition: 0.5s;
  background-size: 200% auto;
  background-image: linear-gradient(to right, #3cd2ef 0%, #3c9bef 51%, #3c9bef 80%);
  border-radius: 10px;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
  font-weight: bold;
  font-size: 0.9em;
  text-align: center;
  text-transform: uppercase;
  float: right;
}
.file-input:hover::before {
  border-color: black;
}
.file-input:active {
  outline: 0;
}
.file-input:active::before {
  background-position: right center;
}
.submit-btn {
  margin: auto;
  padding: 15px 60px;
  text-transform: uppercase;
  font-size: 1.1em;
  font-weight: bold;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  border-radius: 5px;
  border: none;
  background-image: linear-gradient(to right, #3cd2ef 0%, #3c9bef 51%, #3c9bef 80%);
  text-align: center;
}
.submit-btn:hover {
  background-position: right center; /* change the direction of the change here */
  background-image: linear-gradient(to right, #3c9bef 0%, #3c9bef 51%, #3cd2ef 100%);
}
.btn-contain {
  height: 9rem;
  margin: auto;
  margin-top: 2rem;
  width: 70%;
  text-align: center;
}
.input-form {
  margin-top: 3rem;
  margin-bottom: 5rem;
}
.form-group {
  margin-top: 2rem;
  margin-left: 3.5rem;
  margin-bottom: 2rem;
  transition: all .25s;
}
.form-icon {
  margin-top: 2rem;
  margin-left: 1.7rem;
  margin-bottom: 2rem;
}
.form-term {
  display: flex;
  margin-left: 1.5rem;
  margin-top: 1.5rem;
}
.form-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  clear: both;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  margin-left: 3.5rem;
}
.form-url {
  display: flex;
  align-items: center;
  justify-content: space-between;
  clear: both;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  margin-left: 3.5rem;
}
.form-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  clear: both;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  margin-left: 3.5rem;
}
.form-image {
  display: flex;
  align-items: center;
  justify-content: space-between;
  clear: both;
  margin-top: 3rem;
  margin-bottom: 4.5rem;
  margin-left: 3.5rem;
}
.form-qr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  clear: both;
  margin-left: 3.5rem;
}
.form-label {
  font-size: 0.9em;
  color: #aaa;
  display: block;
  opacity: 1;
  transform: translateY(-1.7em);
  transform-origin: 0 0;
  transition: all .25s;
  pointer-events: none;
}
.form-control {
  box-shadow: none;
  background-color: transparent;
  border-radius: 0px;
  border-color: #ccc;
  border-style: none none solid none;
  border-bottom: 2px solid #ccc;;
  width: 100%;
  box-sizing: border-box;
  transition: all .5s;
  padding-bottom: 0.2rem;
  color: white;
}
.form-control:-webkit-autofill,
.form-control:-webkit-autofill:hover, 
.form-control:-webkit-autofill:focus {
  -webkit-text-fill-color: white;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset;
  transition: background-color 5000s ease-in-out 0s;
}
.form-control::placeholder {
  color: transparent;
}
.form-control:focus {
  box-shadow: none;
  outline: none;
  border-color: #3cd2ef;
  font-size: 0.9em;
}
.form-control:not(:placeholder-shown) {
  font-size: 0.9em;
}
.form-control:focus + .form-label,
.form-control:not(:placeholder-shown) + .form-label {
  transform:translateY(-3rem) scale(1);
  color: #3cd2ef;
}
#user-img {
  background-color: #3cd2ef;
  color: white;
  font-size: 7rem; 
  text-align: center;
  padding: 0.4rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  border-radius: 10%;
}
@media screen and (max-width: 300px){
  .form-text {
    display: block;
  }
  .file-input {
    margin-top: 1rem;
    width: 100%;
  }
  #user-img {
    font-size: 5rem; 
  }
  .submit-btn {
    padding: 5vw 13vw;
    font-size: 1rem;
  }
}
@media screen and (max-width: 360px){
  .unlocked {
    margin-left: -0.2px;
  }
  .unlocked:before {
    margin-left: -3.2px;
  }
}
</style>
